import { configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import { useDispatch, useSelector } from 'react-redux';
import rootReducer from './rootReducer';
import customMiddleware from './middleware'

const {
  createReduxHistory,
  routerMiddleware,
  routerReducer
} = createReduxHistoryContext({ history: createBrowserHistory() });

// 添加 routerReducer 到根 reducer
const combinedReducer = {
  router: routerReducer, // 路由状态
  ...rootReducer, // 其他 reducers
};

// 创建 Redux Store
const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // 禁用序列化检查（如有非序列化对象）
    }).concat(routerMiddleware as any), // 添加路由中间件
});

// 定义类型
export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// 自定义 Hook
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppState = <T extends (state: AppState) => any>(selector: T): ReturnType<T> => useSelector(selector);

export const history = createReduxHistory(store);

export default store;
